import { render, staticRenderFns } from "./AddSuppPurchase.vue?vue&type=template&id=4a656f98&"
import script from "./AddSuppPurchase.vue?vue&type=script&lang=js&"
export * from "./AddSuppPurchase.vue?vue&type=script&lang=js&"
import style0 from "./AddSuppPurchase.vue?vue&type=style&index=0&id=4a656f98&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports